import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';

// gsap.config({
//   nullTargetWarn: false,
// });
function buttonFunction() {
	if($(".wp-block-thefuturblocks-button__link").length > 0) {
		$(".wp-block-thefuturblocks-button__link").each(function() {
			const self = $(this),
			    text = self.find('.wp-block-thefuturblocks-button__text'),
			    tl = gsap.timeline({paused:true});

			tl.to(text, {duration:0.2,skewY:-8,yPercent:-100,ease: "sine.in", force3D:false})
			.fromTo(text, {yPercent:100,skewY:8}, {duration:0.2,skewY:0,yPercent:0,immediateRender:false,ease:"sine.out", force3D:false});

			self.on("mouseenter", () => {
				tl.play();
			}).on("mouseleave", () => {
				tl.reverse();
			})

		})
	}
}
buttonFunction();